export default "__VITE_ASSET__9a76c5bc__"